import { RouteConfig, Route, NavigationGuardNext } from "vue-router";
import webSalesOffersSettingService from '@/apps/shared/services/webSalesOffersSettings-service';
const tabOneWelcome = () => import("./quote/views/tab-one.vue");
const tabTwoElectronicDevice = () => import("./quote/views/tab-two.vue");
const tabThreeRange = () => import("./quote/views/tab-three.vue");
const tabFourPlans = () => import("./quote/views/tab-four.vue");
const clientData = () => import("./quote/ClientData.vue");
const FinalPayment = () => import("./quote/finalPayment.vue");
const equipmentSummary = () => import("./quote/equipmentSummary.vue");
const pageTitle = 'Cotizá tu seguro de PC, Notebook o Tablet | Sancor Seguros';
const contentMetaData = 'Protegé tu PC, Notebook o Tablet estés donde estés con nuestro seguro de Tecnología.'

const routes: Array<RouteConfig> = [
    {
        path: "/tecnologia/cotizarEquipoElectronico",
        name: "cotizador-equipo-electronico",
        component: tabTwoElectronicDevice,
        meta: {
            title: () => 'Tecnología',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/tecnologia/valorEquipoElectronico",
        name: "electronic-equipment-range-view",
        component: tabThreeRange,
        meta: {
            title: () => 'Valor del equipo electrónico',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/tecnologia/elegiPlan",
        name: "electronic-equipment-plans-view",
        component: tabFourPlans,
        meta: {
            title: () => 'Elegi el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/tecnologia/elegiPlan/:subpath*",
        name: "electronic-equipment-plans-view2",
        component: tabFourPlans,
        props: (route) => {
            return {
                offer: route.params.offer
            };
        },
        meta: {
            title: () => 'Elegi el Plan',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                }
            ]
        },
        beforeEnter: async (to: any, from: any, next: any): Promise<void> => {
            NF.UI.Page.block();
            try {
                const subpath = to.fullPath.split('/').pop();
                const actualPath = 'tecnologia/elegiPlan';
                const response = await webSalesOffersSettingService.getWebSalesOffersSettings(subpath, actualPath);
                if (response?.pageCustomization) {
                    let pageCustomization = typeof response.pageCustomization === 'string'
                        ? JSON.parse(response.pageCustomization) : null;

                    if (Object.keys(pageCustomization).length > 0) {
                        to.params.offer = {
                            OffersSettings: response.pageCustomization
                        };
                        sessionStorage.setItem("rutaAlternativa", to.fullPath);
                        next();
                    } else {
                        next({ name: 'not-found' });
                    }
                } else {
                    next({ name: 'not-found' });
                }
            }
            catch {
                next({ name: 'not-found' });
            } finally {
                NF.UI.Page.unblock();
            }
        },
    },

    {
        path: "/tecnologia/datosCliente",
        name: "ElectronicDeviceClientData",
        component: clientData,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    {
        path: "/tecnologia/finContrato",
        name: "ElectronicDeviceFinalPayment",
        component: FinalPayment,
        meta: {
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { ParamId, ExternalIdentifier, ChannelId } = to.query as {
                ParamId?: string;
                ExternalIdentifier?: string;
                ChannelId?: string;
            };

            // Si llega alguno de los tres parámetros, se guarda en sessionStorage
            if (ParamId || ExternalIdentifier || ChannelId) {
                if (ParamId) {
                    sessionStorage.setItem("ParamId", ParamId);
                }
                if (ExternalIdentifier) {
                    sessionStorage.setItem("PricingId", ExternalIdentifier);
                }
                if (ChannelId) {
                    sessionStorage.setItem("ChannelId", ChannelId);
                }

                sessionStorage.setItem("ExitOrContinueModal", "false");

                const timeStart = new Date();
                sessionStorage.setItem("TimeStartPaymentComplete", JSON.stringify(timeStart));

                // Redirigimos a la misma ruta SIN query para limpiarla
                next({ path: to.path, query: {} });
            } else {
                // Si no hay query params, seguimos normalmente
                next();
            }
        }
    },
    {
        path: "/tecnologia/resumen",
        name: "ElectronicDeviceSummary",
        component: equipmentSummary,
        meta: {
            title: () => 'Resumen',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        }
    },
    // Ruta comodín debe ir al final siempre
    {
        path: "/tecnologia/:subpath*",
        name: "electronic-equipment-tab-One",
        component: tabOneWelcome,
        meta: {
            title: () => 'Datos personales',
            pageTitle: pageTitle,
            metaTags: [
                {
                    name: 'description',
                    content: contentMetaData
                },
            ]
        },
        beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
            const { utm_source } = to.query as { utm_source?: string };

            const existente = sessionStorage.getItem("Referente");
            if (!existente) {
                if (utm_source) {
                    sessionStorage.setItem("Referente", utm_source);
                }
                else {
                    if (document.referrer != '') {
                        sessionStorage.setItem("Referente", document.referrer);
                    }
                    else {
                        sessionStorage.setItem("Referente", null);
                    }
                }
            }

            const { utm_medium } = to.query as { utm_medium?: string };

            const existente_medium = sessionStorage.getItem("Medium");
            if (!existente_medium) {
                if (utm_medium) {
                    sessionStorage.setItem("Medium", utm_medium);
                }
                else {
                    sessionStorage.setItem("Medium", 'organic');                    
                }
            }

            if (Object.keys(to.query).length > 0) {
                next({ path: to.path, query: {} });
            } else {
                next();
            }
        }
    },
];

export default routes;
